// src/pages/Buyer/Buyer/Buyer.js
import { useState, useContext, useCallback, useMemo, useEffect } from "react";
import { useForm } from "react-hook-form";
// import { useParams } from "react-router-dom";
import { useModal } from "../../../context/ModalContext";
import { ThemeContext } from "../../../context/ThemeContext";
import MainHeader from "../../../components/header/MainHeader";
import AddressSearchPreview from "../AddressSearchPreview";
import { formatCurrency } from "../../../utils/format";
import { useCurrencyFormat } from "./hooks/useCurrencyFormat";
import FloatingInput from "../../../components/input/FloatingInput";
import FloatingNumber from "../../../components/input/FloatingNumber";
import CustomSelect from "../../../components/customselect/CustomSelect";

import ResultsModal from "./components/ResultsModal";
import ManualSheetSection from "./components/ManualSheetSection";
import PropertyDetailsSection from "./components/PropertyDetailsSection";
import { useDispatch } from "react-redux";

import { calculatePropNine } from "./utils/calculations";

import { setBuyerFormData } from "../../../store/slices/buyerSlice";
import { useSelector } from "react-redux";
import "../../../calculater.css";
import "../../../responsiveness.css";
import { CommonHeader } from "../../../components/ui/CommonHeader";
// import store from "../../../store";
import Toast from "../../../components/common/Toast";
import { propninePayload } from "../../../utils/payloadBuilder";
import { generatePdf } from "../PdfRouteService";
// import { fetchPrintDisclaimerForPdf } from "../../../utils/disclaimerApi";

const PropNineNetSheet = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useContext(ThemeContext);

  const buyerformData = useSelector((state) => state.buyer.formData);
  const templateformData = useSelector((state) => state.buyer.templateData);

  // const mainId = theme?.id || "";
  // const user = JSON.parse(localStorage.getItem("user") || "{}");
  // const userId = user?.id;
  // const stateid = user?.state;

  const { openModal, closeModal } = useModal();

  // const [step, setStep] = useState(1);
  // const [companyId, setCompanyId] = useState(user?.companyid || null);
  // const [main_company_name, setMainCompanyId] = useState(
  //   theme?.main_company_name || null
  // );
  const main_company_name = theme?.main_company_name || null;
 // const mainId = theme?.id || "";

  // route param and guards used by loadExisting and template loader
  // const params = useParams();
  // const calcId = params?.id || 0;
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // const [isEditLoading, setIsEditLoading] = useState(false);

  const [formData, setFormData] = useState({});

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const defaultValues = useMemo(
    () =>
    ({
      ...formData,
    }[formData])
  );
  const { control, setValue, getValues } = useForm({ defaultValues });

  const [ttbData, setTtbData] = useState({});
  // const [salesPriceError, setSalesPriceError] = useState("");
  // const [purchasePriceError, setpPurchasePriceError] = useState("");
  const salesPriceError = "";
  const purchasePriceError = "";
  const [isCorrectProperty, setIsCorrectProperty] = useState(true);
  const [showPreviewFromChild, setShowPreviewFromChild] = useState(false);
  const [useAnnualPropertyTax, setUseAnnualPropertyTax] = useState(true);
  const [showManualSheet, setShowManualSheet] = useState(false);
  const [toast, setToast] = useState({
    message: "",
    visible: false,
    type: "success",
  });

  // Currency formatting hook
  const handleCurrencyBlur = useCurrencyFormat(formData, setFormData);

  // const parseCurrency = (val) => {
  //   const n = Number(String(val ?? "").replace(/[^0-9.-]+/g, ""));
  //   return Number.isFinite(n) ? n : 0;
  // };

  const resetPropNineDefaults = useCallback(() => {
    setFormData((prev) => ({
      ...prev,
      phase: "",
      preparedFor: "New Client",
      preparedBy: "",
      addressVerified: false,
      loanInfoMeta: {},
      addressMeta: {},
      estimatedTaxes: {},
      salesPrice: "0.00",
      purchasePrice: "0.00",
    }));
    //  console.log("setFormData reset: 5");
    setTtbData({});
    setIsCorrectProperty(false);
    setUseAnnualPropertyTax(true); // Reset to default value
    setShowPreviewFromChild(false);
  }, []); // Remove useAnnualPropertyTax from dependencies since we're setting it to a fixed value

  // Watch formData changes and dispatch to Redux store
  useEffect(() => {
    if (Object.keys(formData).length > 0) {
      dispatch(setBuyerFormData(formData));
    }
  }, [formData, dispatch]);

  //  Cleanup / Unmounting (Page Leave)
  useEffect(() => {
    return () => {
      resetPropNineDefaults();
    };
  }, [resetPropNineDefaults]);

  // Sync TTB data with form data
  useEffect(() => {
    if (Object.keys(formData).length > 0 && Object.keys(ttbData).length > 0) {
      setFormData((prev) => {
        const currentAssessedValue = prev.loanInfoMeta?.assessedValueAmount;
        const currentAnnualPropertyTax = prev.loanInfoMeta?.annualPropertyTax;
        const currentCaTaxRate = prev.loanInfoMeta?.caTaxRate;
        const currentAdjustedCashPercent = prev.loanInfoMeta?.adjustedCashPercent;
        const currentInflationRate = prev.loanInfoMeta?.inflationRate;

        // Only update if we need to change from current state
        const needsAssessedValueUpdate = useAnnualPropertyTax
          ? (ttbData?.assessedValue && currentAssessedValue !== ttbData.assessedValue)
          : (currentAssessedValue !== "0.00");

        const needsAnnualTaxUpdate = useAnnualPropertyTax
          ? (ttbData?.assessedValue && currentAnnualPropertyTax !== ttbData.assessedValue)
          : (currentAnnualPropertyTax !== "0.00");

        const needsCaTaxRateUpdate = ttbData?.caTaxRate && currentCaTaxRate !== ttbData.caTaxRate;
        const needsAdjustedCashPercentUpdate = ttbData?.adjustedCashPercent && currentAdjustedCashPercent !== ttbData.adjustedCashPercent;
        const needsInflationRateUpdate = ttbData?.inflationRate && currentInflationRate !== ttbData.inflationRate;

        // Only update if something actually needs to change
        if (!needsAssessedValueUpdate && !needsAnnualTaxUpdate && !needsCaTaxRateUpdate && !needsAdjustedCashPercentUpdate && !needsInflationRateUpdate) {
          return prev;
        }

        return {
          ...prev,
          loanInfoMeta: {
            ...(prev.loanInfoMeta || {}),
            ...(useAnnualPropertyTax
              ? { assessedValueAmount: ttbData?.assessedValue || prev.loanInfoMeta?.assessedValueAmount }
              : { assessedValueAmount: "0.00" }),
            ...(useAnnualPropertyTax
              ? { annualPropertyTax: ttbData?.assessedValue || prev.loanInfoMeta?.annualPropertyTax }
              : { annualPropertyTax: "0.00" }),
            ...(needsCaTaxRateUpdate ? { caTaxRate: ttbData.caTaxRate } : {}),
            ...(needsAdjustedCashPercentUpdate ? { adjustedCashPercent: ttbData.adjustedCashPercent } : {}),
            ...(needsInflationRateUpdate ? { inflationRate: ttbData.inflationRate } : {}),
          },
        };
      });
    }
    // formData is read inside setFormData callback; omit to avoid effect running on every form change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useAnnualPropertyTax, ttbData]); // Depend on both useAnnualPropertyTax and ttbData

  const handlePropNineEstimate = useCallback((formData) => {
    getPropNineEstimate(formData);
  }, []);

  const getPropNineEstimate = async (formData) => {
    //console.log("getPropNineEstimate triggered 11");
    const result = calculatePropNine(formData);
    //  console.log("getPropNineEstimate triggered", result);

    setFormData((prev) => {
      return {
        ...prev,
        estimatedTaxes: {
          ...(prev.estimatedTaxes || {}),
          saleBetween365: result.saleBetween365,
          saleBetween730: result.saleBetween730,
        },
      };
    });
  };

  // Inside SellerNetSheet component
  // const handleCalAmount = useCallback();

  // ✅ Main calculation handler
  const handleCalculate = async () => {
    if (!buyerformData?.salesPrice || Number(buyerformData.salesPrice) === 0) {
      openModal({
        title: "Warnings",
        size: "smallmodel",
        content: (
          <div class="modelspace application-fe">
            <p class="model-desc-details notice-icon">
              You haven't entered a Sales and Purchase Price.
              <br />
              Do you want to continue without a Sales and Purchase Price?
            </p>
            <div className="frm-btn popup-2-btn">
              <button
                class="submit-btn btn-bg inpt-btn btn-discard"
                onClick={() => closeModal()}
              >
                Cancel
              </button>
              <button
                class="submit-btn btn-bg inpt-btn"
                onClick={() => {
                  closeModal();
                  runCalculation();
                }}
              >
                Continue
              </button>
            </div>
          </div>
        ),
      });

      return;
    }

    runCalculation();
  };

  const runCalculation = () => {
    // console.log("runCalculation triggered 11", buyerformData);
    finalCosts = getPropNineEstimate(buyerformData);
    setTimeout(() => {
      openModal({
        title: "Prop 19 Calculator Results",
        size: "halffull",
        content: renderModal(1),
      });
    }, 50);
  };

  // const handleLoanAmount = useCallback();

  const handleCancelModal = () => {
    closeModal();
    setTimeout(() => {
      openModal({
        title: "Prop 19 Calculator Results",
        size: "halffull",
        content: renderModal(1),
      });
    }, 50);
  };

  const handleCancelResultModal = () => {
    closeModal();
    setTimeout(() => {
      openModal({
        title: "What would you like to do next?",
        size: "smallmodel",
        content: renderModal(2),
      });
    }, 50);
  };

  let finalCosts;
  // Reusable modal rendering
  const renderModal = (currentStep) => (
    <ResultsModal
      step={currentStep}
      setStep={(newStep) => {
        // setStep(newStep);
        openModal({
          title: "What would you like to do next?",
          size: "smallmodel",
          content: renderModal(newStep),
        });
      }}
      closeModal={closeModal}
      onEditManual={() => {
        closeModal();
        setShowManualSheet(true);
      }}
      cancelModal={handleCancelModal}
      formData={finalCosts} // ✅ use the updated data, not stale formData
      result={finalCosts}
      resetPropNineDefaults={resetPropNineDefaults}
      formatCurrency={formatCurrency}
      handleDownloadPrintPDF={handleDownloadPrintPDF}
      cancelResultModal={handleCancelResultModal}
      showToaster={handleUpdateToaster}
    />
  );

  const checkValidSalesPrice = () => {
    const formatted = String(formData.salesPrice).replace(/,/g, "");
    const value = Number(formatted);
    if (!value) {
      handleUpdateToaster({
        message: "Failure! Please enter a Sales Price",
        visible: true,
        type: "error",
      });
    }
    return !isNaN(value) && value !== 0;
  };

  const handleDownloadPrintPDF = async (type, buyerformData = []) => {
    try {
      //   console.log(`handleDownloadPrintPDF called with type: ${type}`);
      const isValid = checkValidSalesPrice();
      const user = JSON.parse(localStorage.getItem("user"));
      if (!isValid) return;
      const payload = propninePayload({
        buyerformData, user, payload: {
          mrsid: formData?.addressMeta?.mrsid,
          optionType: type === "download" ? "download" :
            type === "print" ? "printdetailedestimate" :
              "download"
        }
      });
      //  const printDisclaimer = await fetchPrintDisclaimerForPdf({        maincompanyid: mainId,        calcSlug: undefined,        pdfType: "propnine",      });
      // console.log('Generating PDF with payload:', payload);
      const data = await generatePdf({ type: "propnine", data: { ...payload, 
      //   disclaimer: printDisclaimer 
      } });
      // console.log('Received PDF data from server:', data);

      const blob = new Blob([data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      if (type === "download") {
        // window.open(blobUrl, "_blank");

        const link = document.createElement("a");
        link.href = blobUrl;
        // link.download = `document-buyer-${Date.now()}.pdf`;

        let preparedFor = (payload?.preparedFor || "New_Client")
          .replace(/\s+/g, "_") // replace spaces with _
          .replace(/[^a-zA-Z0-9_]/g, ""); // remove unsafe characters

        let timestamp = Math.floor(Date.now() / 1000); // 10-digit timestamp

        link.download = `Print_for_${preparedFor}_${timestamp}.pdf`;

        document.body.appendChild(link);
        link.click(); // Forces download
        link.remove();

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 5000);
      }

      if (type === "print") {
        const printWindow = window.open("", "_blank", "width=900,height=700");

        if (printWindow) {
          printWindow.document.write(`
      <html>
        <head>
          <title>Print PDF</title>
        </head>
        <body style="margin:0;">

          <iframe id="printFrame"
            src="${blobUrl}"
            style="width:100%; height:100%; border:none;">
          </iframe>

          <script>
            const frame = document.getElementById('printFrame');
            frame.onload = function () {
              // wait a bit for PDF viewer to fully initialize
              setTimeout(() => {
                frame.contentWindow.focus();
                frame.contentWindow.print();
              }, 300);
            };
          </script>

        </body>
      </html>
    `);

          printWindow.document.close();
        }
      }
    } catch (error) {
      console.warn("Error while downloading and print pdf", error);
    }
  };

  const handleUpdateToaster = ({ message, visible, type = "success" }) => {
    setToast({ message, visible, type });
    setTimeout(
      () => setToast({ message: "", visible: false, type: "success" }),
      5000
    );
  };

  return (
    <div className="calculater-layout">
      <div className="calculator-header">
        <MainHeader />
      </div>

      <div>
        <div className="back-inner">
          {!showManualSheet && (
            <CommonHeader
              title={`Prop 19 Calculator for Primary Residence`}
              subTitle={`Enter the property address and all the other details.`}
            />
          )}
        </div>
      </div>

      <div
        className={`calc-container ${showManualSheet === true ? "calc-page" : " double-height"
          }`}
      >
        <div className="clc-mid-contain">
          {!showManualSheet && (
            <AddressSearchPreview
              mode="propnine1"
              control={control}
              setValue={setValue}
              getValues={getValues}
              openModal={openModal}
              closeModal={closeModal}
              onEnriched={(data) => {
                //   console.log("onEnriched data:", data);
                // eslint-disable-next-line no-unused-vars
                const { ttb, payload, raw, showPreview, fromParcelSelection } = data || {};

                const enrichment = payload?.enrichment;
                const oldmrsid = formData?.addressMeta?.mrsid || "";
                const timestamp = Date.now();

                //  console.log("onEnriched data:", enrichment);
                // If no property data came back (ttb & raw are null or empty)
                const propertyUnavailable =
                  (!ttb || Object.keys(ttb || {}).length === 0) &&
                  (!raw || Object.keys(raw || {}).length === 0);

                if (payload?.mode === "propnine1") {
                  resetPropNineDefaults();
                }

                if (propertyUnavailable) {
                  console.warn(
                    "AddressSearchPreview: Property not available — resetting default values"
                  );

                  // Reset all core fields
                  setFormData((prev) => ({
                    ...prev,
                    addressVerified: false, // Address is invalid
                  }));

                  handleUpdateToaster &&
                    handleUpdateToaster({
                      message:
                        "The address you entered is incorrect or the State/County is not supported.",
                      visible: true,
                      type: "error",
                    });

                  return; // Stop further processing
                }
                //   console.log("ttb in propnine index 11", ttb);

                if (ttb) setTtbData(ttb);
                // if (raw?.data?.companyid) {
                //   setCompanyId(raw.data.companyid);
                // }
                if (payload) {
                  const addDays = (date, days) => {
                    const d = new Date(date);
                    d.setDate(d.getDate() + days);
                    return d;
                  };
                  const toDateStr = (d) =>
                    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
                      2,
                      "0"
                    )}-${String(d.getDate()).padStart(2, "0")}`;
                  const defaultEst = toDateStr(addDays(new Date(), 30));
                  //   console.log("setFormData address: 7");

                  if (payload?.mode === "propnine1") {
                    setFormData((prev) => {
                      // Build a human-readable address from payload if available
                      // const streetNo = payload.street_no || "";
                      // const route = payload.route_long || payload.route || "";
                      const siteUnit = payload.site_unit || "";
                      // Construct formatted address from components if not provided
                      const formattedAddress = payload.formatted_address ||
                        (payload.street_no && payload.route_long ?
                          `${payload.street_no} ${payload.route_long}${payload.site_unit ? ' #' + payload.site_unit : ''}, ${payload.city}, ${payload.state_code} ${payload.zip}` :
                          "");

                      //   console.log("No enrichment data — not found");
                      return {
                        ...prev,
                        phase: "AddressSearchPreview",
                        addressVerified: fromParcelSelection ? true : (enrichment ? true : prev.addressVerified),
                        main_company_name: main_company_name,
                        loanInfoMeta: {
                          ...(prev.loanInfoMeta || {}),
                          estimatedClosingDate: defaultEst,
                          ...(useAnnualPropertyTax
                            ? { assessedValueAmount: ttb?.assessedValue }
                            : { assessedValueAmount: "0.00" }),
                          caTaxRate: ttb?.caTaxRate,
                          adjustedCashPercent: ttb?.adjustedCashPercent,
                          inflationRate: ttb?.inflationRate,
                          ...(useAnnualPropertyTax
                            ? { annualPropertyTax: ttb?.assessedValue }
                            : { annualPropertyTax: "0.00" }),
                        },
                        // put structured address under the address node only
                        addressMeta: {
                          companyid: raw?.data?.companyid || "",
                          address: formattedAddress,
                          countyid:
                            ttb?.countyid ||
                            payload?.countyid ||
                            prev?.address?.countyid ||
                            "",
                          stateid:
                            ttb?.stateid ||
                            payload?.stateid ||
                            prev?.address?.stateid ||
                            "",
                          city: raw?.data?.city || prev?.address?.city || "",
                          state:
                            raw?.data?.state_code ||
                            payload?.state ||
                            prev?.address?.state ||
                            "",
                          zip: payload?.zip || prev?.address?.zip || "",
                          addressIncludesUnit: !!(payload?.site_unit && payload?.site_unit.trim()),
                          unitNumber:
                            siteUnit || prev?.address?.unitNumber || "",
                          mrsid: oldmrsid ? oldmrsid : `${timestamp}`,
                        },
                      };
                    });
                  }
                }
                setShowPreviewFromChild(Boolean(showPreview));
                setIsInitialLoad(Boolean(showPreview));
                setIsCorrectProperty(true);
              }}
              // ✅ handle manual typing too
              onAddressEdited={(val) => {
                if (val && val.length > 3) {
                  setIsCorrectProperty(false); // Reset confirmation when user changes or reselects address
                  setIsInitialLoad(false);
                  // No need to reset useAnnualPropertyTax here as it will be reset when isCorrectProperty becomes false
                }
              }}
            />
          )}

          {showPreviewFromChild && !showManualSheet && (
            <PropertyDetailsSection
              ttbData={ttbData}
              formatCurrency={formatCurrency}
              salesPriceError={salesPriceError}
              purchasePriceError={purchasePriceError}
              isCorrectProperty={isCorrectProperty}
              isInitialLoad={isInitialLoad}
              setIsCorrectProperty={setIsCorrectProperty}
              setIsInitialLoad={setIsInitialLoad}
              useAnnualPropertyTax={useAnnualPropertyTax}
              setUseAnnualPropertyTax={setUseAnnualPropertyTax}
              formData={formData}
              setFormData={setFormData}
              handleCurrencyBlur={handleCurrencyBlur}
              handleCalculate={handleCalculate}
            />
          )}
        </div>

        {showManualSheet && (
          <ManualSheetSection
            FloatingInput={FloatingInput}
            FloatingNumber={FloatingNumber}
            CustomSelect={CustomSelect}
            formatCurrency={formatCurrency}
            salesPriceError={salesPriceError}
            // navigate={navigate}
            isCorrectProperty={isCorrectProperty}
            setIsCorrectProperty={setIsCorrectProperty}
            useAnnualPropertyTax={useAnnualPropertyTax}
            setUseAnnualPropertyTax={setUseAnnualPropertyTax}
            handleCurrencyBlur={handleCurrencyBlur}
            handleCalculate={handleCalculate}
            checkValidSalesPrice={checkValidSalesPrice}
            formData={formData}
            setFormData={setFormData}
            handlePropNineEstimate={handlePropNineEstimate}
            templateformData={templateformData}
            // handleLoanAmount={handleLoanAmount}
            handleDownloadPrintPDF={handleDownloadPrintPDF}
            showToaster={handleUpdateToaster}
          // setCompanyId={setCompanyId}
          />
        )}

        <Toast
          message={toast.message}
          type={toast.type}
          visible={toast.visible}
        />
      </div>
    </div>
  );
};

export default PropNineNetSheet;
